import React, { useState } from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  greyColours,
  brandColours,
  fontSize,
  zIndexLayers,
  visuallyHidden,
} from '../styles';
import { Button } from './ui';
import Calendar from './Calendar';
import { useCalendar, formatDate } from '../utils';

const StyledSpaSearchCalendar = styled.div`
  position: absolute;
  left: 50%;
  z-index: ${zIndexLayers.first};
  min-width: 320px;
  background-color: ${standardColours.white};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 12px 0 ${standardColours.transparentBlack(0.4)};
  transform: translateX(-50%);

  ${maxBreakpointQuery.mlarge`
    width: 100%;
  `}
`;

const StyledTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid ${greyColours.lightGrey};
`;

const StyledDate = styled.p`
  margin: 0 15px;
  padding: 2px 0;
  ${fontSize(22)};
  border-bottom: 2px solid ${brandColours.primary};

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `}
`;

const StyledClose = styled.button`
  padding: 15px;

  &:before {
    content: '✕';
    color: ${brandColours.primary};
    ${fontSize(24)};
  }

  span {
    ${visuallyHidden()};
  }
`;

const StyledCalendar = styled(Calendar)`
  display: flex;
  flex-direction: column;
  padding-right: 5px;
  padding-left: 5px;
`;

const StyledButton = styled(Button)`
  align-self: flex-end;
  margin: 0 20px 5px;
  width: 200px;
`;

const SpaSearchCalendar = ({
  searchType,
  selectedDate,
  setSelectedDate,
  setShow,
}) => {
  const todaysDate = new Date();

  const [startDate, setStartDate] = useState(todaysDate);

  const calendarMonths = useCalendar({
    start: startDate,
    months: 2,
    //locationId: initialLocation ? initialLocation.id : null, - MA - Don't use location yet, otherwise this can result in a blank calendar for cities/towns as it is not a radial search
    searchType: searchType || 'All',
  });

  return (
    <StyledSpaSearchCalendar>
      <StyledTop>
        <StyledDate>
          {formatDate(selectedDate && selectedDate.date, true) || 'Any Date'}
        </StyledDate>
        <StyledClose onClick={() => setShow(false)}>
          <span>Close</span>
        </StyledClose>
      </StyledTop>
      <StyledCalendar
        months={calendarMonths}
        startDate={startDate}
        setStartDate={setStartDate}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        isSearch={true}
      >
        <StyledButton alt={true} onClick={() => setShow(false)}>
          Done
        </StyledButton>
      </StyledCalendar>
    </StyledSpaSearchCalendar>
  );
};

export default SpaSearchCalendar;
